import React, { useState, useEffect } from 'react';
import { getPageContent, subscribeToPage } from '../firebase/firebase-config';

function Teachers() {
  const [content, setContent] = useState({ teachers: [], sliderImages: [] });
  const [loading, setLoading] = useState(true);
  const [department, setDepartment] = useState('all');

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await getPageContent('teachers');
        setContent(data);
      } catch (error) { console.error(error); }
      finally { setLoading(false); }
    };
    loadData();
    const unsubscribe = subscribeToPage('teachers', (data) => { if (data) setContent(data); });
    return () => unsubscribe();
  }, []);

  const departments = ['all', ...new Set((content.teachers || []).map(t => t.subject || 'General'))];

  const filteredTeachers = (content.teachers || []).filter(t => department === 'all' || t.subject === department);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <div className="teachers-page">
      {content.sliderImages && content.sliderImages.length > 0 && (
        <div className="page-banner"><img src={content.sliderImages[0].url} alt="Teachers" /><div className="banner-overlay"><h1>Our Teachers</h1></div></div>
      )}
      <div className="container">
        <div className="department-filter"><select value={department} onChange={(e) => setDepartment(e.target.value)}>{departments.map(d => <option key={d} value={d}>{d === 'all' ? 'All Departments' : d}</option>)}</select></div>
        <div className="teachers-grid">
          {filteredTeachers.map((teacher) => (
            <div key={teacher.id} className="teacher-card">
              {teacher.photo && <img src={teacher.photo} alt={teacher.name} />}
              <div className="teacher-info"><h3>{teacher.name}</h3><span className="position">{teacher.position}</span>{teacher.subject && <span className="subject">{teacher.subject}</span>}{teacher.qualification && <p>{teacher.qualification}</p>}{teacher.experience && <small>{teacher.experience} years experience</small>}</div>
            </div>
          ))}
        </div>
      </div>
      <style>{`
        .teachers-page { background: #f8fafc; min-height: 100vh; }
        .page-banner { position: relative; height: 300px; overflow: hidden; }
        .page-banner img { width: 100%; height: 100%; object-fit: cover; }
        .banner-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; }
        .banner-overlay h1 { color: white; font-size: 48px; }
        .container { max-width: 1200px; margin: 0 auto; padding: 60px 20px; }
        .department-filter { text-align: center; margin-bottom: 40px; }
        .department-filter select { padding: 10px 20px; border: 1px solid #e2e8f0; border-radius: 8px; background: white; min-width: 200px; }
        .teachers-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 30px; }
        .teacher-card { background: white; border-radius: 16px; overflow: hidden; text-align: center; box-shadow: 0 2px 8px rgba(0,0,0,0.1); transition: transform 0.3s; }
        .teacher-card:hover { transform: translateY(-5px); }
        .teacher-card img { width: 100%; height: 250px; object-fit: cover; }
        .teacher-info { padding: 20px; }
        .teacher-info h3 { color: #1a3a6b; margin-bottom: 5px; }
        .position { display: inline-block; background: #f59e0b; color: white; padding: 4px 12px; border-radius: 20px; font-size: 12px; margin: 5px 0; }
        .subject { display: inline-block; background: #10b981; color: white; padding: 2px 8px; border-radius: 20px; font-size: 11px; margin-left: 5px; }
        .teacher-info p { color: #64748b; font-size: 13px; margin-top: 8px; }
        .teacher-info small { color: #94a3b8; font-size: 11px; }
        .loading { display: flex; justify-content: center; align-items: center; min-height: 60vh; }
        .spinner { width: 50px; height: 50px; border: 4px solid #e2e8f0; border-top-color: #1a3a6b; border-radius: 50%; animation: spin 1s linear infinite; }
        @keyframes spin { to { transform: rotate(360deg); } }
        @media (max-width: 768px) { .banner-overlay h1 { font-size: 32px; } }
      `}</style>
    </div>
  );
}
export default Teachers;